import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, filter, map, of, tap } from 'rxjs';
import { MaintenanceActions } from '@features/maintenance/store/maintenance.actions';
import { MaintenanceService } from '@features/maintenance/service/maintenance.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

export const load$ = createEffect(
  (
    actions$ = inject(Actions),
    maintenanceService = inject(MaintenanceService)
  ) => {
    return actions$.pipe(
      ofType(MaintenanceActions.loadMaintenance),
      concatMap(() =>
        maintenanceService.getMaintenance().pipe(
          map((maintenance) => MaintenanceActions.loadMaintenanceSuccess({ maintenance })),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 0) {
              return of(MaintenanceActions.loadMaintenanceSuccess({ 
                maintenance : {
                  activated: true,
                  title: "Le site est actuellement en cours de maintenance",
                  message: "Sachez que nos équipes sont déjà à pied d'œuvre pour un retour à la normale dans les meilleurs délais et nous vous remercions de votre patience."
                }
              }));
            }
            return of(MaintenanceActions.loadMaintenanceFailure({error: error.error}));
          })
        )
      )
    );
  },
  { functional: true }
);

export const redirectToHomeOnActivated$ = createEffect(
  (
    actions$ = inject(Actions),
    router = inject(Router)
  ) => {
    return actions$.pipe(
      ofType(MaintenanceActions.loadMaintenanceSuccess),
      filter(({ maintenance }) => maintenance.activated === true),
      tap(() => {
        router.navigate(['/'], { queryParams: { redirectAllowed: true } });
      })
    );
  },
  { functional: true, dispatch: false }
);
